import { OptimizedImage } from '@/infrastructure/class/optimized-image';

const SMALL_BREAKPOINT = 200;
const MEDIUM_BREAKPOINT = 640;

export const getResponsiveImageLoader =
  (image: OptimizedImage) =>
  ({ width }: { width: number }): string => {
    if (width <= SMALL_BREAKPOINT) {
      return image.smallUrl || image.mediumUrl || image.optimizedUrl;
    }
    if (width <= MEDIUM_BREAKPOINT) {
      return image.mediumUrl || image.optimizedUrl || image.smallUrl;
    }
    return image.optimizedUrl || image.mediumUrl || image.smallUrl;
  };
